import userManagementService from '../services/userManagementService';

export const fetchAllUsers = async () => {
  const result = await userManagementService.getAllUsers();
  if (!result?.success) {
    const error = new Error(result?.message || 'Failed to fetch users');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchUserById = async (id) => {
  const result = await userManagementService.getUserById(id);
  if (!result?.success) {
    const error = new Error(result?.message || 'Failed to fetch user');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchAllRoles = async () => {
  const result = await userManagementService.getAllRoles();
  if (!result?.success) {
    const error = new Error(result?.message || 'Failed to fetch roles');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const createUser = async (payload) => {
  const result = await userManagementService.createUser(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Failed to create user');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const updateUser = async (payload) => {
  // payload model:
  // { id: string, username: string, password: string, isActive: boolean, roles: string[] }
  const result = await userManagementService.updateUser(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Failed to update user');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const deleteUser = async (id) => {
  const result = await userManagementService.deleteUser(id);
  if (!result?.success) {
    const error = new Error(result?.message || 'Failed to delete user');
    error.details = result;
    throw error;
  }
  return result.data;
};

export default {
  fetchAllUsers,
  fetchUserById,
  fetchAllRoles,
  createUser,
  updateUser,
  deleteUser,
};


